import { I18nPagePropertyEnum } from "../../i18n/i18n_page_property";

export enum OrderStatusEnum {
  /**
   * Ödeme yapılmadı
   */
  paymentNotMade = "Payment not made",
  paymentCompleted = "Payment completed",
}
export enum OrderProductStatusEnum {
  /**
   * Onay bekleyen
   */
  pendingApproval = "pendingApproval",
  /**
   * Onaylandı
   */
  approved = "approved",
  /**
   * İptal edildi
   */
  cancelled = "cancelled",
  /**
   * Hazırlanıyor
   */
  preparing = "preparing",
  /**
   * Hazır
   */
  ready = "ready",
  /**
   * Teslim edildi
   */
  delivered = "delivered",
  /**
   * Stokta yok
   */
  outOfStock = "outOfStock",
}
declare global {
  interface String {
    orderProductStatusLang(): string;
    orderStatusLang(): string;
  }
}

// eslint-disable-next-line no-extend-native
String.prototype.orderProductStatusLang = function (this: string): string {
  switch (this) {
    case OrderProductStatusEnum.pendingApproval:
      return I18nPagePropertyEnum.commonPendingApproval;
    case OrderProductStatusEnum.approved:
      return I18nPagePropertyEnum.commonApproved;
    case OrderProductStatusEnum.cancelled:
      return I18nPagePropertyEnum.commonItIsCancelled;
    case OrderProductStatusEnum.preparing:
      return I18nPagePropertyEnum.commonPreparing;
    case OrderProductStatusEnum.ready:
      return I18nPagePropertyEnum.commonReady;
    case OrderProductStatusEnum.delivered:
      return I18nPagePropertyEnum.commonDelivered;
    case OrderProductStatusEnum.outOfStock:
      return I18nPagePropertyEnum.commonOutOfStock;
    default:
      return "";
  }
};
// eslint-disable-next-line no-extend-native
String.prototype.orderStatusLang = function (this: string): string {
  switch (this) {
    case OrderStatusEnum.paymentNotMade:
      return I18nPagePropertyEnum.commonPaymentNotMade;
    case OrderStatusEnum.paymentCompleted:
      return I18nPagePropertyEnum.commonPaymentCompleted;
    default:
      return "";
  }
};
